import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState, useEffect } from 'react';
import { c as compareMessagesForGrouping, u as useChannelContext, i as isAboutSame } from '../../ChannelProvider-5dcbee7b.js';
import { P as PlaceHolder, a as PlaceHolderTypes } from '../../index-2cfab646.js';
import Icon, { IconTypes, IconColors } from '../../ui/Icon.js';
import Message from './Message.js';
import { i as isSameDay } from '../../index-ad50e2c0.js';
import UnreadCount from './UnreadCount.js';
import FrozenNotification from './FrozenNotification.js';
import { S as SCROLL_BUFFER } from '../../consts-fa6ab3c0.js';
import useSendbirdStateContext from '../../useSendbirdStateContext.js';
import { MessageProvider } from '../../Message/context.js';
import { u as useDebounce, a as useHandleOnScrollCallback } from '../../index-dd5a8777.js';
import '../../UserProfileContext-f3f446d2.js';
import 'prop-types';
import '../../const-72f012b6.js';
import '../../index-ccef08fe.js';
import '../../index-6add7940.js';
import '../../topics-eb548880.js';
import '../../index-579ca9d7.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../compareIds-2e50e905.js';
import '@sendbird/chat/groupChannel';
import '../../uuid-717930b4.js';
import '@sendbird/chat/message';
import '../../resolvedReplyType-9d00a3db.js';
import '../../LocalizationContext-a82461b5.js';
import '../../stringSet-b60e9529.js';
import '../../index-6420013c.js';
import '../../ui/Loader.js';
import './SuggestedMentionList.js';
import '../../ui/Avatar.js';
import '../../ui/ImageRenderer.js';
import '../../const-3a34a127.js';
import '../../ThreadProvider-cf357120.js';
import '../../Thread/context/types.js';
import '@sendbird/chat';
import '../../ui/DateSeparator.js';
import '../../color-91e43dce.js';
import '../../ui/MessageInput.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import 'dompurify';
import '../../consts-b4cb83cf.js';
import '../../consts-7693b8d3.js';
import '../../consts-9469111b.js';
import '../../tokenize-c718324d.js';
import '../../index.module-4f1cd64e.js';
import '../../ui/MessageContent.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../utils-e0c7329c.js';
import '../../index-ac0b2d20.js';
import '../../index-f879f6ef.js';
import '../../ui/MessageItemMenu.js';
import '../../ui/ContextMenu.js';
import 'react-dom';
import '../../ui/SortByRow.js';
import '../../types-95cfd227.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/ReactionButton.js';
import '../../useLongPress-12280c78.js';
import '../../MediaQueryContext-d6110905.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/BottomSheet.js';
import '../../index-a9101009.js';
import '../../ui/UserListItem.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../ui/AdminMessage.js';
import '../../ui/TextMessageItemBody.js';
import '../../index-a2bb2783.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ui/FileMessageItemBody.js';
import '../../ui/TextButton.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/OGMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import '../../ui/QuoteMessage.js';
import '../../index-86294a68.js';
import '../../ui/ThreadReplies.js';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../index-fa5b2b8c.js';
import '../../VoiceRecorder/context.js';
import '../../ui/Modal.js';
import '../../withSendbird.js';
import '../../ui/PlaybackTime.js';
import './FileViewer.js';
import './RemoveMessageModal.js';
import '../../useDirtyGetMentions-dffd4046.js';
var getMessagePartsInfo = function getMessagePartsInfo(_ref) {
  var _ref$allMessages = _ref.allMessages,
    allMessages = _ref$allMessages === void 0 ? [] : _ref$allMessages,
    _ref$isMessageGroupin = _ref.isMessageGroupingEnabled,
    isMessageGroupingEnabled = _ref$isMessageGroupin === void 0 ? true : _ref$isMessageGroupin,
    _ref$currentIndex = _ref.currentIndex,
    currentIndex = _ref$currentIndex === void 0 ? 0 : _ref$currentIndex,
    _ref$currentMessage = _ref.currentMessage,
    currentMessage = _ref$currentMessage === void 0 ? null : _ref$currentMessage,
    _ref$currentChannel = _ref.currentChannel,
    currentChannel = _ref$currentChannel === void 0 ? null : _ref$currentChannel,
    _ref$replyType = _ref.replyType,
    replyType = _ref$replyType === void 0 ? '' : _ref$replyType;
  var previousMessage = allMessages[currentIndex - 1];
  var nextMessage = allMessages[currentIndex + 1];
  var _ref3 = isMessageGroupingEnabled ? compareMessagesForGrouping(previousMessage, currentMessage, nextMessage, currentChannel, replyType) : [false, false],
    _ref4 = _slicedToArray(_ref3, 2),
    chainTop = _ref4[0],
    chainBottom = _ref4[1];
  var previousMessageCreatedAt = previousMessage === null || previousMessage === void 0 ? void 0 : previousMessage.createdAt;
  var currentCreatedAt = currentMessage.createdAt;
  // https://stackoverflow.com/a/41855608
  var hasSeparator = !(previousMessageCreatedAt && isSameDay(currentCreatedAt, previousMessageCreatedAt));
  return {
    chainTop: chainTop,
    chainBottom: chainBottom,
    hasSeparator: hasSeparator
  };
};
var DELAY = 500;
function useSetScrollToBottom(_ref) {
  var loading = _ref.loading;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollBottom = _useState2[0],
    setScrollBottom = _useState2[1];
  useEffect(function () {
    if (loading) {
      setScrollBottom(0);
    }
  }, [loading]);
  var scrollCb = function scrollCb(e) {
    var element = e.target;
    try {
      setScrollBottom(element.scrollHeight - element.scrollTop - element.offsetHeight);
    } catch (_unused) {
      //
    }
  };
  return {
    scrollBottom: scrollBottom,
    scrollToBottomHandler: useDebounce(scrollCb, DELAY)
  };
}
var SCROLL_BOTTOM_PADDING = 50;
var MessageList = function MessageList(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    renderMessage = _ref.renderMessage,
    renderPlaceholderEmpty = _ref.renderPlaceholderEmpty,
    renderCustomSeparator = _ref.renderCustomSeparator,
    renderPlaceholderLoader = _ref.renderPlaceholderLoader;
  var _useChannelContext = useChannelContext(),
    allMessages = _useChannelContext.allMessages,
    hasMorePrev = _useChannelContext.hasMorePrev,
    hasMoreNext = _useChannelContext.hasMoreNext,
    setInitialTimeStamp = _useChannelContext.setInitialTimeStamp,
    setAnimatedMessageId = _useChannelContext.setAnimatedMessageId,
    setHighLightedMessageId = _useChannelContext.setHighLightedMessageId,
    isMessageGroupingEnabled = _useChannelContext.isMessageGroupingEnabled,
    scrollRef = _useChannelContext.scrollRef,
    onScrollCallback = _useChannelContext.onScrollCallback,
    onScrollDownCallback = _useChannelContext.onScrollDownCallback,
    messagesDispatcher = _useChannelContext.messagesDispatcher,
    messageActionTypes = _useChannelContext.messageActionTypes,
    currentGroupChannel = _useChannelContext.currentGroupChannel,
    disableMarkAsRead = _useChannelContext.disableMarkAsRead,
    filterMessageList = _useChannelContext.filterMessageList,
    replyType = _useChannelContext.replyType,
    loading = _useChannelContext.loading,
    unreadSince = _useChannelContext.unreadSince;
  var store = useSendbirdStateContext();
  var allMessagesFiltered = typeof filterMessageList === 'function' ? allMessages.filter(filterMessageList) : allMessages;
  var markAsReadScheduler = store.config.markAsReadScheduler;
  var onScroll = function onScroll() {
    var element = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
    if (element == null) {
      return;
    }
    var scrollTop = element.scrollTop,
      clientHeight = element.clientHeight,
      scrollHeight = element.scrollHeight;
    if (isAboutSame(scrollTop, 0, SCROLL_BUFFER)) {
      onScrollCallback(function (messages) {});
    }
    if (isAboutSame(clientHeight + scrollTop, scrollHeight, SCROLL_BUFFER) && hasMoreNext) {
      onScrollDownCallback(function (_ref2) {});
    }
    if (!disableMarkAsRead && isAboutSame(clientHeight + scrollTop, scrollHeight, SCROLL_BUFFER) && !!currentGroupChannel) {
      messagesDispatcher({
        type: messageActionTypes.MARK_AS_READ,
        payload: {
          channel: currentGroupChannel
        }
      });
      markAsReadScheduler.push(currentGroupChannel);
    }
  };
  var onClickScrollBot = function onClickScrollBot() {
    var _scrollRef$current;
    setInitialTimeStamp === null || setInitialTimeStamp === void 0 ? void 0 : setInitialTimeStamp(null);
    setAnimatedMessageId === null || setAnimatedMessageId === void 0 ? void 0 : setAnimatedMessageId(null);
    setHighLightedMessageId === null || setHighLightedMessageId === void 0 ? void 0 : setHighLightedMessageId(null);
    if ((scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollTop) > -1) {
      var _scrollRef$current$sc, _scrollRef$current2, _scrollRef$current$of, _scrollRef$current3;
      scrollRef.current.scrollTop = ((_scrollRef$current$sc = scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 ? void 0 : _scrollRef$current2.scrollHeight) !== null && _scrollRef$current$sc !== void 0 ? _scrollRef$current$sc : 0) - ((_scrollRef$current$of = scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef$current3 = scrollRef.current) === null || _scrollRef$current3 === void 0 ? void 0 : _scrollRef$current3.offsetHeight) !== null && _scrollRef$current$of !== void 0 ? _scrollRef$current$of : 0);
    }
  };

  /**
   * Move the messsage list scroll
   * when each message's height is changed by `reactions` OR `showEdit`
   */
  var handleMessageHeightChange = function handleMessageHeightChange() {
    var current = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
    if (current) {
      var bottom = current.scrollHeight - current.scrollTop - current.offsetHeight;
      if (scrollBottom < bottom) {
        // Move the scroll as much as the height of the message has changed
        current.scrollTop += bottom - scrollBottom;
      }
    }
  };
  // Keep the scrollBottom value after fetching new message list
  var handleMessageListHeightChange = function handleMessageListHeightChange() {
    var current = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current;
    if (current) {
      var bottom = current.scrollHeight - current.scrollTop - current.offsetHeight;
      if (scrollBottom < bottom) {
        current.scrollTop += bottom - scrollBottom;
      }
    }
  };
  var handleOnScroll = useHandleOnScrollCallback({
    hasMore: hasMorePrev,
    hasNext: hasMoreNext,
    onScroll: onScroll,
    scrollRef: scrollRef
  });
  var _useSetScrollToBottom = useSetScrollToBottom({
      loading: loading
    }),
    scrollToBottomHandler = _useSetScrollToBottom.scrollToBottomHandler,
    scrollBottom = _useSetScrollToBottom.scrollBottom;
  if (loading) {
    return typeof renderPlaceholderLoader === 'function' ? renderPlaceholderLoader() : /*#__PURE__*/React__default.createElement(PlaceHolder, {
      type: PlaceHolderTypes.LOADING
    });
  }
  if (allMessagesFiltered.length < 1) {
    if (renderPlaceholderEmpty && typeof renderPlaceholderEmpty === 'function') {
      return renderPlaceholderEmpty();
    }
    return /*#__PURE__*/React__default.createElement(PlaceHolder, {
      className: "sendbird-conversation__no-messages",
      type: PlaceHolderTypes.NO_MESSAGES
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-conversation__messages ".concat(className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-conversation__scroll-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-conversation__padding"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-conversation__messages-padding",
    ref: scrollRef,
    onScroll: function onScroll(e) {
      handleOnScroll();
      scrollToBottomHandler(e);
    }
  }, allMessagesFiltered.map(function (m, idx) {
    var _sender, _store$config;
    var _getMessagePartsInfo = getMessagePartsInfo({
        allMessages: allMessagesFiltered,
        replyType: replyType,
        isMessageGroupingEnabled: isMessageGroupingEnabled,
        currentIndex: idx,
        currentMessage: m,
        currentChannel: currentGroupChannel
      }),
      chainTop = _getMessagePartsInfo.chainTop,
      chainBottom = _getMessagePartsInfo.chainBottom,
      hasSeparator = _getMessagePartsInfo.hasSeparator;
    var isByMe = (m === null || m === void 0 ? void 0 : (_sender = m.sender) === null || _sender === void 0 ? void 0 : _sender.userId) === (store === null || store === void 0 ? void 0 : (_store$config = store.config) === null || _store$config === void 0 ? void 0 : _store$config.userId);
    return /*#__PURE__*/React__default.createElement(MessageProvider, {
      message: m,
      key: m === null || m === void 0 ? void 0 : m.messageId,
      isByMe: isByMe
    }, /*#__PURE__*/React__default.createElement(Message, {
      handleScroll: handleMessageHeightChange,
      handleMessageListHeightChange: handleMessageListHeightChange,
      renderMessage: renderMessage,
      message: m,
      hasSeparator: hasSeparator,
      chainTop: chainTop,
      chainBottom: chainBottom,
      renderCustomSeparator: renderCustomSeparator
    }));
  }))), (currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.isFrozen) && /*#__PURE__*/React__default.createElement(FrozenNotification, {
    className: "sendbird-conversation__messages__notification"
  }), unreadSince && /*#__PURE__*/React__default.createElement(UnreadCount, {
    className: "sendbird-conversation__messages__notification",
    count: currentGroupChannel === null || currentGroupChannel === void 0 ? void 0 : currentGroupChannel.unreadMessageCount,
    time: unreadSince,
    onClick: function onClick() {
      var _scrollRef$current4;
      if (scrollRef !== null && scrollRef !== void 0 && (_scrollRef$current4 = scrollRef.current) !== null && _scrollRef$current4 !== void 0 && _scrollRef$current4.scrollTop) {
        var _scrollRef$current$sc2, _scrollRef$current5, _scrollRef$current$of2, _scrollRef$current6;
        scrollRef.current.scrollTop = ((_scrollRef$current$sc2 = scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef$current5 = scrollRef.current) === null || _scrollRef$current5 === void 0 ? void 0 : _scrollRef$current5.scrollHeight) !== null && _scrollRef$current$sc2 !== void 0 ? _scrollRef$current$sc2 : 0) - ((_scrollRef$current$of2 = scrollRef === null || scrollRef === void 0 ? void 0 : (_scrollRef$current6 = scrollRef.current) === null || _scrollRef$current6 === void 0 ? void 0 : _scrollRef$current6.offsetHeight) !== null && _scrollRef$current$of2 !== void 0 ? _scrollRef$current$of2 : 0);
      }
      if (!disableMarkAsRead && !!currentGroupChannel) {
        markAsReadScheduler.push(currentGroupChannel);
        messagesDispatcher({
          type: messageActionTypes.MARK_AS_READ,
          payload: {
            channel: currentGroupChannel
          }
        });
      }
      setInitialTimeStamp(null);
      setAnimatedMessageId(null);
      setHighLightedMessageId(null);
    }
  }),
  // This flag is an unmatched variable
  scrollBottom > SCROLL_BOTTOM_PADDING && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-conversation__scroll-bottom-button",
    onClick: onClickScrollBot,
    onKeyDown: onClickScrollBot,
    tabIndex: 0,
    role: "button"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    width: "24px",
    height: "24px",
    type: IconTypes.CHEVRON_DOWN,
    fillColor: IconColors.PRIMARY
  })));
};
export { MessageList as default };